import UibookCase from 'uibook/case'
import React from 'react'
import TelegramButton from '../TelegramButton'

const I18N = {
  ru: {
    small: 'Small размер',
    medium: 'Medium размер',
    large: 'Large размер',
    stretch: 'Растянутая кнопка',
    ios: 'iOS радиус',
    hintSmall: 'Компактный размер для плотных интерфейсов.',
    hintMedium: 'Базовый размер для большинства экранов.',
    hintLarge: 'Крупный размер для важных CTA блоков.',
    hintStretch: 'Кнопка растягивается по ширине контейнера.',
    hintIos: 'iOS-поведение с другим радиусом углов.',
  },
  en: {
    small: 'Small size',
    medium: 'Medium size',
    large: 'Large size',
    stretch: 'Stretched button',
    ios: 'iOS radius',
    hintSmall: 'Compact size for dense layouts.',
    hintMedium: 'Default balanced button size.',
    hintLarge: 'Large call-to-action presentation.',
    hintStretch: 'Button takes full width of its container.',
    hintIos: 'iOS-flavored radius and surface behavior.',
  }
}

const PROPS = {
  onClick: UibookCase.event('onTelegramSizeClick')
}

export default {
  background: 'light',
  component: TelegramButton,
  i18n: true,
  cases: [
    locale => <UibookCase props={{ ...PROPS, size: 's', mode: 'filled', description: I18N.en.hintSmall }}>
      { I18N[locale].small }
    </UibookCase>,
    locale => <UibookCase props={{ ...PROPS, size: 'm', mode: 'bezeled', description: I18N.en.hintMedium }}>
      { I18N[locale].medium }
    </UibookCase>,
    locale => <UibookCase props={{ ...PROPS, size: 'l', mode: 'outline', description: I18N.en.hintLarge }}>
      { I18N[locale].large }
    </UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      size: 'm',
      mode: 'filled',
      stretched: true,
      containerWidth: 340,
      description: I18N.en.hintStretch
    }}>
      { I18N[locale].stretch }
    </UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      size: 'm',
      mode: 'plain',
      platform: 'ios',
      description: I18N.en.hintIos
    }}>
      { I18N[locale].ios }
    </UibookCase>
  ]
}
